<template>
<qb-panel title="" class="qb-margin-top">
    <qb-table/>
</qb-panel>
</template>

<script>
import QbTable from "./table.vue";
// import axios from "axios";
// import { baseApiUrl, userKey } from "@/global"
export default {
    
    components: {
        QbTable
    },     
    data(){
        return{
        }
    },
    methods: {
    }
}
</script>

<style scoped>
</style>
